export default {"src":"/_next/static/media/laptop-cracked.4a185729.svg","height":67,"width":99};